'use client';

import { useContext } from 'react';
/// React router dom
import { Routes, Route, Outlet, Navigate } from 'react-router-dom';
import { homeForRole } from '../store/actions/AuthActions';
import { useSelector } from 'react-redux';
/// Css
import './index.css';
/// Layout
import Nav from './layouts';
import Footer from './layouts/Footer';
import BackToTop from './layouts/BackToTop';
import Watermark from './layouts/Watermark';
import ScrollToTop from './layouts/ScrollToTop';
import { TopbarSlotProvider } from './layouts/TopbarSlot';
/// Dashboard
import Home from './components/Dashboard/Home';
// import Task from "./components/Dashboard/Task";
/// Form
import StudentFeedbackForm from './components/Forms/StudentFeedbackForm/StudentFeedbackForm';
import FeedbackTest from './components/Forms/StudentFeedbackForm/FeedbackTest';
/// Pages
import LockScreen from './pages/LockScreen';
import Error404 from './pages/Error404';
import { ThemeContext } from '../context/ThemeContext';
import Logout from './layouts/Logout';
import ProgressCard from './components/ProgressCard/ProgressCard';
import Student from './components/Student/Dashboard/StudentDashboard.jsx';
import InterviewCard from './components/InterviewQuestionCard/InterviewCard';
import AccordionComp from './components/AccordionComp/AccordionComp';
import Calendar from './components/AppMenu/Calendar/Calendar';
import HeroSection1 from './components/Dashboard_section2/HeroSection1';
import TransactionTable from './components/Fees/TransactionTable';
import CourseCompletionCertificate from './components/CourseCompletion/CourseCompletionCertificate';
import TabComponent from './components/Progress/TabComponent';
import JobSection from './components/JobSection/JobSection';
import JobBoard from './components/JobBoard/JobBoard';
import HelpCenter from './components/HelpDesk/HelpCenter';
import QuerySubmitted from './components/HelpDesk/QuerySubmitted';
import ReferralProgram from './components/ReferralProgram/ReferralProgram';
import RankingDashboard from './components/RankingDashboard/RankingDashboard';
import Certificate from './components/Student/Certificate/Certificate.jsx';
import { StudentDashboard2 } from './components/Student/Dashboard/StudentDashboard2.jsx';
import SuggestedBatches from './components/Student/SuggestedBatches/SuggestedBatches.jsx';
import StudentIdCard from './components/StudentIdCard/StudentIdCard';
import StudentProfile from './components/Student/StudentProfile/StudentProfile.jsx';
import AddBatch from './components/Forms/BatchForm/AddBatch.jsx';
import SyllabusForm from './components/Forms/SyllabusForm/SyllabusForm.jsx';
import CourseModule from './components/Forms/CourseModule/CourseModule.jsx';
import Attendance from './components/Trainer/Attendance/AddAttendance.jsx';
import ListBatch from './components/Forms/BatchForm/ListBatch.jsx';
import ListCourseModule from './components/Forms/CourseModule/ListCourseModule.jsx';
import AddAttendance from './components/Trainer/Attendance/AddAttendance.jsx';
import ListAttendance from './components/Trainer/Attendance/ListAttendance.jsx';
import McqList from './components/Trainer/Mcq/McqList.jsx';
import AddMcq from './components/Trainer/Mcq/AddMcq.jsx';
import DisplayMcqCourse from './components/Trainer/Mcq/DisplayMcqCourse.jsx';
import AddClassroom from './components/Forms/Classroom/AddClassroom.jsx';
import ListClassroom from './components/Forms/Classroom/ListClassroom.jsx';
import ListEvent from './components/EventForm/ListEvent.jsx';
import AddEvent from './components/EventForm/AddEvent.jsx';
import Notifications from './components/Notifications/Notifications.jsx';
import MockInterviews from './components/MockInterviews/MockInterviews.jsx';
import TrainerBatches from './components/Trainer/Mcq/TrainerBatches/TrainerBatches.jsx';
import AdminStatistics from './components/AdminStatistics/AdminStatistics.jsx';
// Student MCQ Components
import DisplayEnrolledCourse from './components/Student/studentmcq/DisplayEnrolledCourse.jsx';

import StudentMcqView from './components/Student/studentmcq/StudentMcqView.jsx';
// import Todolist from "./components/Todolist.jsx";
import AddOperation from './components/Settings/Opreations/AddOpreation.jsx';
import ListOperation from './components/Settings/Opreations/ListOpreation.jsx';
import AppearanceSettings from './components/Settings/Appearance/AppearanceSettings.jsx';
// import ListApps from "./components/Settings/App/ListApp.jsx";
import AddApps from './components/setting/Apps/AddApp.jsx';
import ClassroomApp from './apps/ClassroomApp/index.jsx';
import BatchRequestsList from './components/BatchRequests/BatchRequestsList.jsx';
import AddAssignModules from './components/setting/assignmodule/AddAssignModules.jsx';
import AssignModules from './components/setting/assignmodule/AssignModules.jsx';
import AddRole from './components/setting/roles/AddRoles.jsx';
import Role from './components/setting/roles/Roles.jsx';
import AddApptoRole from './components/setting/ApptoRole/AddApptoRole.jsx';
import ListApptoRole from './components/setting/ApptoRole/ListApptoRole.jsx';
import AddUser from './components/setting/user/AddUser.jsx';
import User from './components/setting/user/User.jsx';
import UserProfile from './components/User/UserProfile/UserProfile.jsx';
import TrainerDashboard from './components/Trainer/TrainerDashoard.jsx';
// Rebuilt trainer dashboard — new IA, from-scratch UI. Runs alongside the
// old one until its remaining tabs are ported.
import TrainerDashboardV2 from './components/Trainer/dashboard/index.jsx';
import ListStudentUsers from './components/setting/Student/ListStudentUsers.jsx';
import AddQuiz from './components/Trainer/Quiz/AddQuiz.jsx';
import ListQuiz from './components/Trainer/Quiz/ListQuiz.jsx';
import StudentQuizList from './components/Student/Quizz/StudentQuizList.jsx';
import StudentQuiz from './components/Student/Quizz/StudentQuiz.jsx';
import AdminCalendar from './components/AppMenu/Calendar/AdminCalendar/AdminCalendar.jsx';
import OMList from './components/setting/OperationstoModules/OMList.jsx';
import AddOMList from './components/setting/OperationstoModules/AddOM.jsx';
import AppList from './components/setting/Apps/AppList.jsx';
import MTAppList from './components/setting/ModulesToApps/MTAppList.jsx';
import AddMTApps from './components/setting/ModulesToApps/AddMTApps.jsx';
import AddTrainer from './components/Trainer/AddTrainer.jsx';
import ListTrainer from './components/Trainer/ListTrainer.jsx';
import AssignBatch from './components/AssignBatch/AssignBatch.jsx';
import StudentCalendar from './components/AppMenu/Calendar/Student/StudentCalendar.jsx';
import StudentAttendanceRecord from './components/Student/Attendance/StudentAttendanceRecord.jsx';
import StudentAttendanceReport from './components/Student/Attendance/StudentAttendanceReport.jsx';
import TrainerCalendar from './components/AppMenu/Calendar/Trainer/TrainerCalendar.jsx';
import AssignQuizToBatch from './components/Trainer/AssignQuizToBatch.jsx';
import ListQuizToBatch from './components/Trainer/ListQuizToBatch.jsx';
import PostJobs from './components/JobSection/Jobs/PostJobs.jsx';
import ListJobs from './components/JobSection/Jobs/ListJobs.jsx';
import ListSyllabus from './components/Forms/SyllabusForm/ListSyllabuses.jsx';
import StudentFromBilling from './components/Student/StudentFromBilling.jsx';
import MockInterView from './components/MockSection/MockInterView.jsx';
import StudentMockInterview from './components/Student/MockInterview/StudentMockInterview.jsx';

// Mailer Metas
import ListMailerMeta from './components/MailerMetas/ListMailerMetas.jsx';
import AddMailerMeta from './components/MailerMetas/AddMailerMetas.jsx';

// Email Templates
import ListEmailTemplate from './components/EmailTemplates/ListEmailTemplates.jsx';
import AddEmailTemplate from './components/EmailTemplates/AddEmailTemplate.jsx';
// Email Event Configs
import ListEmailEventConfig from './components/EmailEventConfigs/ListEmailEventConfigs.jsx';
import AddEmailEventConfig from './components/EmailEventConfigs/AddEmailEventConfig.jsx';
import { components } from 'react-select';
import AttendanceReportSystem from './components/AttendanceReportSystem/AttendanceReportSystem.jsx';
import StudentsReport from './components/Student/StudentsReport/StudentsReport.jsx';
import SessionFeedback from './components/Feedback/SessionFeedback.jsx';
import BatchReportPage from './components/Reports/BatchReport/BatchReportPage.jsx';
import CrmReports from './components/CrmReports/CrmReports.jsx';
import AiBoard from './components/AiBoard/AiBoard.jsx';
// Reached from the admin and trainer dashboards; not in the sidebar yet.
import ReportGenerator from './components/ReportGenerator/ReportGenerator.jsx';
// Reached from the account menu; administrators decide on the dashboard's Access tab.
import AccessCenter from './components/AccessCenter/AccessCenter.jsx';
import { isComingSoon } from '../utils/comingSoon';
import { usePageRefreshKey } from './layouts/pageRefresh';
import AddStudentUser from './components/setting/Student/AddStudentUser.jsx';
import AddSource from './components/setting/Source/AddSource.jsx';
import ListSource from './components/setting/Source/ListSource.jsx';
import Chat from './components/Chat/Chat.jsx';

const Markup = () => {
  const allroutes = [
    /// Dashboard
    { url: '', component: <Home /> },
    { url: 'dashboard', component: <Home /> },

    { url: 'user-profile', component: <UserProfile /> },

    // Form
    { url: 'Student-Admission-From', component: <StudentFeedbackForm /> },
    { url: 'feedback-test', component: <FeedbackTest /> },
    // Pages
    { url: 'student-profile', component: <StudentProfile /> },
    { url: 'logout', component: <Logout /> },
    // progress card
    { url: 'progress-card', component: <ProgressCard /> },
    // ==================
    { url: 'job-board', component: <JobBoard /> },
    { url: 'student-dashboard', component: <Student /> },
    { url: 'interview-card', component: <InterviewCard /> },
    { url: 'admin-statistics', component: <AdminStatistics /> },
    { url: 'accordian-comp', component: <AccordionComp /> },
    // { url: "event-calendar", component: <Calendar /> },
    {
      url: 'attendance-report-system',
      component: <AttendanceReportSystem />,
    },
    { url: 'student-calendar', component: <Calendar /> },
    { url: 'admin-calendar', component: <AdminCalendar /> },
    { url: 'trainer-calendar', component: <TrainerCalendar /> },

    { url: 'mock-interview', component: <MockInterView /> },
    { url: 'Dashboard_section2', component: <HeroSection1 /> },
    { url: 'transactionTable', component: <TransactionTable /> },
    { url: 'course-certificate', component: <CourseCompletionCertificate /> },
    { url: 'progress', component: <TabComponent /> },
    { url: 'job-Section', component: <JobSection /> },
    { url: 'post-jobs', component: <PostJobs /> },
    { url: 'list-jobs', component: <ListJobs /> },
    { url: 'edit/:id', component: <PostJobs /> },

    { url: 'help-desk', component: <HelpCenter /> },
    { url: 'query-submitted', component: <QuerySubmitted /> },
    { url: 'Referral-Program', component: <ReferralProgram /> },
    { url: 'ranking-dashboard', component: <RankingDashboard /> },
    { url: 'certificate', component: <Certificate /> },
    { url: 'Student-Dashboard2', component: <StudentDashboard2 /> },
    { url: 'suggested-batches', component: <SuggestedBatches /> },
    { url: 'student-id-card', component: <StudentIdCard /> },
    { url: 'mock-interviews', component: <MockInterviews /> },
    { url: 'notifications', component: <Notifications /> },
    { url: 'event-form', component: <AddEvent /> },
    { url: 'add-batch', component: <AddBatch /> },
    { url: 'add-batch/:id', component: <AddBatch /> },
    { url: 'batches', component: <ListBatch /> },
    { url: 'add-classroom', component: <AddClassroom /> },
    { url: 'edit-classroom/:id', component: <AddClassroom /> },
    { url: 'list-classroom', component: <ListClassroom /> },
    { url: 'syllabus-form', component: <SyllabusForm /> },
    { url: 'edit-syllabus/:id', component: <SyllabusForm /> },
    { url: 'list-syllabuses', component: <ListSyllabus /> },
    { url: 'course-module', component: <CourseModule /> },
    { url: 'edit-course/:id', component: <CourseModule /> },
    { url: 'attendance-module', component: <Attendance /> },
    { url: 'list-event-Form', component: <ListEvent /> },
    { url: 'List-Course', component: <ListCourseModule /> },
    { url: 'course-wise-mcq', component: <DisplayMcqCourse /> },
    { url: 'course-wise-mcq/:courseId', component: <McqList /> },
    { url: 'course-wise-mcq/add', component: <AddMcq /> },
    { url: 'course-wise-mcq/edit/:id', component: <AddMcq /> },
    { url: 'trainer-batches', component: <TrainerBatches /> },
    { url: 'add-attendance/:id', component: <AddAttendance /> },
    { url: 'add-attendance', component: <AddAttendance /> },
    { url: 'list-attendance', component: <ListAttendance /> },
    { url: 'session-feedback', component: <SessionFeedback /> },
    { url: 'access-center', component: <AccessCenter /> },
    { url: '/event-form/:id', component: <AddEvent /> },
    { url: 'student-courses', component: <DisplayEnrolledCourse /> },
    { url: 'add-student-user', component: <AddStudentUser /> },
    { url: 'add-student-user/:id', component: <AddStudentUser /> },
    { url: 'student-mcq-view/:courseId', component: <StudentMcqView /> },
    // A personal preference, not an administrative setting -- no
    // permission gate, because it changes nothing anyone else can see.
    { url: 'setting/appearance', component: <AppearanceSettings /> },
    { url: 'setting/Add-opreation', component: <AddOperation /> },
    { url: 'setting/list-opreation', component: <ListOperation /> },
    { url: 'setting/list-apps', component: <AppList /> },
    { url: 'setting/add-app', component: <AddApps /> },
    { url: 'setting/edit-app/:id', component: <AddApps /> },
    { url: 'setting/list-modules', component: <AssignModules /> },
    { url: 'setting/add-modules', component: <AddAssignModules /> },
    { url: 'setting/edit-modules/:id', component: <AddAssignModules /> },
    { url: 'setting/add-Roles', component: <AddRole /> },
    { url: 'setting/list-Roles', component: <Role /> },
    { url: 'setting/edit-Roles/:id', component: <AddRole /> },
    { url: 'setting/operationstomodules', component: <OMList /> },
    { url: 'setting/add-operation-to-modules', component: <AddOMList /> },
    { url: 'setting/edit-operation-to-modules/:id', component: <AddOMList /> },
    { url: 'setting/mta-list', component: <MTAppList /> },
    { url: 'setting/add-module-to-app', component: <AddMTApps /> },
    { url: 'setting/edit-module-to-app/:id', component: <AddMTApps /> },
    { url: 'setting/add-app-to-role', component: <AddApptoRole /> },
    { url: 'setting/list-app-to-role', component: <ListApptoRole /> },
    { url: 'setting/edit-app-to-role/:id', component: <AddApptoRole /> },
    { url: 'setting/adduser', component: <AddUser /> },
    { url: 'setting/List-user', component: <User /> },
    { url: 'setting/edituser/:id', component: <AddUser /> },
    { url: 'classroom-app/*', component: <ClassroomApp /> },
    { url: 'classroom-management', component: <Navigate to="/classroom-app" replace /> },
    { url: 'batch-requests', component: <BatchRequestsList /> },
    { url: 'student-users', component: <ListStudentUsers /> },
    { url: 'trainer-dashboard', component: <TrainerDashboard /> },
    { url: 'trainer-dashboard-v2', component: <TrainerDashboardV2 /> },
    { url: 'trainer-addquiz', component: <AddQuiz /> },
    { url: 'trainer-listquiz', component: <ListQuiz /> },
    { url: 'trainer-addquiz/:id', component: <AddQuiz /> },
    { url: 'student-quizzes', component: <StudentQuizList /> },
    { url: 'student-quiz', component: <StudentQuiz /> },
    { url: 'student-mock-interview', component: <StudentMockInterview /> },
    { url: 'add-trainer', component: <AddTrainer /> },
    { url: 'list-trainer', component: <ListTrainer /> },
    { url: 'add-trainer/edittrainer/:id', component: <AddTrainer /> },
    { url: 'attendance-calendar', component: <StudentCalendar /> },
    { url: 'attendance-record', component: <StudentAttendanceRecord /> },
    { url: 'my-attendance-report', component: <StudentAttendanceReport /> },
    { url: 'assign-quiz-to-batch', component: <AssignQuizToBatch /> },
    { url: 'list-quiz-to-batch', component: <ListQuizToBatch /> },
    { url: 'all-students', component: <StudentFromBilling /> },
    { url: 'assign-quiz-to-batch/:id', component: <AssignQuizToBatch /> }, // Mailer Meta Routes
    { url: 'mailer-metadatas', component: <ListMailerMeta /> },
    { url: 'add-mailer-metadata', component: <AddMailerMeta /> },
    { url: 'add-mailer-metadata/:id', component: <AddMailerMeta /> },
    { url: 'setting/add-source', component: <AddSource /> },
    { url: 'setting/list-source', component: <ListSource /> },
    // Email Template Routes
    { url: 'email-templates', component: <ListEmailTemplate /> },
    { url: 'add-email-template', component: <AddEmailTemplate /> },
    { url: 'add-email-template/:id', component: <AddEmailTemplate /> },

    // Email Event Config Routes
    { url: 'email-event-configs', component: <ListEmailEventConfig /> },
    { url: 'add-email-event-config', component: <AddEmailEventConfig /> },
    { url: 'add-email-event-config/:id', component: <AddEmailEventConfig /> },

    // student report
    { url: 'students-report', component: <StudentsReport /> },
    { url: 'batchreport', component: <BatchReportPage /> },
    // CRM: student and batch performance, one page each.
    { url: 'crm-reports', component: <Navigate to="/crm-reports/students" replace /> },
    { url: 'crm-reports/students', component: <CrmReports kind="students" /> },
    { url: 'crm-reports/batches', component: <CrmReports kind="batches" /> },
    // AI Board: questions about the LMS data, answered from the live database.
    { url: 'ai-board', component: <AiBoard /> },
    { url: 'report-generator', component: <ReportGenerator /> },
    /* One page, three kinds of conversation, picked from the dropdown
       in its header. /assistant is kept as a route rather than folded
       into /chat because it was the address of the AI assistant and is
       linked from the topbar; it now opens the same page with the
       assistant already selected. */
    { url: 'chat', component: <Chat /> },
    { url: 'assistant', component: <Chat defaultMode="ai" /> },
    // Anything listed in COMING_SOON_FEATURES (src/config/watermark.js) is
    // left unregistered, so its url falls through to the 404 page.
  ].filter((route) => !isComingSoon(route.url));

  // function NotFound() {
  //   const url = allroutes.map((route) => route.url);
  //   let path = window.location.pathname;
  //   path = path.split('/');
  //   path = path[path.length - 1];
  //   if (url.indexOf(path) <= 0) {
  //     return <Error404 />;
  //   }
  // }

  function NotFound() {
    const url = allroutes.map((route) => route.url);
    let path = window.location.pathname;
    path = path.split('/');
    path = path[path.length - 1];

    if (url.indexOf(path) <= 0) {
      return <Error404 />;
    }
  }

  return (
    <>
      <Routes>
        <Route path="/page-lock-screen" element={<LockScreen />} />
        <Route path="/page-error-404" element={<Error404 />} />
        <Route
          path="/login"
          element={
            <Navigate to={homeForRole(localStorage.getItem('userRole'))} replace />
          }
        />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route key={i} exact path={`${data.url}`} element={data.component} />
          ))}
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { sidebariconHover } = useContext(ThemeContext);
  const sideMenu = useSelector((state) => state.sideMenu);
  // Bumped by the topbar's refresh button (layouts/pageRefresh.js).
  const pageKey = usePageRefreshKey();
  return (
    <div
      id="main-wrapper"
      className={`show ${sidebariconHover ? 'iconhover-toggle' : ''} ${
        sideMenu ? 'menu-toggle' : ''
      }`}
    >
      {/* The provider has to sit above both the topbar and the Outlet so a
          routed page can hand a control to the bar it does not contain. */}
      <TopbarSlotProvider>
        <Nav />
        <div className="content-body">
          {/* Keyed so a refresh remounts the page and only the page. */}
          <div className="container-fluid" key={pageKey}>
            <Outlet />
          </div>
        </div>
      </TopbarSlotProvider>
      <Footer />
      {/* The watermark (src/config/watermark.js): a faint tiled layer over
          the content area, under the sidebar and the top bar. Clicks,
          selection and screen readers pass straight through it. */}
      <Watermark />
      {/* One back-to-top button for every page in the shell. It renders
          nothing until the reader is well down the page. */}
      <BackToTop />
    </div>
  );
}

export default Markup;
